import { createElement } from 'react';
const ColorfulText = function ColorfulText(props) {
    const { value, style } = props;
    const _style = style || {};
    return createElement("div", { style: _style }, value);
};
ColorfulText.displayName = 'HhText';
export default ColorfulText;
